// extracted by mini-css-extract-plugin
export var cardContainer = "styles-module--cardContainer--iAloP";
export var logoContainer = "styles-module--logoContainer--1mEBk";
export var bottomRowContainer = "styles-module--bottomRowContainer--3EO4C";
export var content = "styles-module--content--3DRbE";
export var name = "styles-module--name--gRmML";
export var about = "styles-module--about--2sbrK";
export var icon = "styles-module--icon--16tiD";